import { NgModule } from '@angular/core';
import { provideRouter } from '@angular/router';
import { LayoutDefaultComponent } from '../common/components/layout-default/layout-default.component';
import { UserAuthGuard } from '../user/guards/user-auth-guard';
import { billingGuard } from './guards/billing.guard';

@NgModule({
  providers: [
    provideRouter([
      {
        path: 'billing',
        component: LayoutDefaultComponent,
        canActivate: [UserAuthGuard, billingGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/billing/billing.component'),
          },
        ],
      },
    ]),
  ],
})
export class BillingRoutingModule {}
